import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';

import Alert from '../alert';
import Title from '../title';
import SplitPurchase from '../../containers/split-purchase.container';
import validate from './validate';
import { EDIT_PURCHASE_NAMESPACE } from '../../actions';
import '../../css/edit-purchase.css';

class EditPurchase extends Component {
  renderAlert() {
    const { error } = this.props;

    if (!error) return null;

    return (
      <Alert type="warning" className="alert-form-top">
        <i className="fa fa-fw fa-ban" />
        {error}
      </Alert>
    );
  }

  renderShortContributorsAlert() {
    const { shortMemberships } = this.props;

    if (shortMemberships.length === 0) return null;

    return (
      <p className="coral-error">
        <FormattedMessage
          id="editPurchase.shortContributorsAlert"
          defaultMessage="These changes cause {short} contributors to be short
            of what they must contribute. We will notify them to approve the
            higher cost for their share."
          values={{ short: shortMemberships.length }}
        />
      </p>
    );
  }

  renderForm() {
    const { handleSubmit, submitting } = this.props;

    return (
      <form className="edit-purchase" onSubmit={handleSubmit(this.props.onSubmit)}>
        <Title
          text={
            <FormattedMessage
              id="editPurchase.howToSplit.title"
              defaultMessage="How to split"
            />
          }
          divider
          className="pb-3"
        />

        <SplitPurchase namespace={EDIT_PURCHASE_NAMESPACE} showMaxSlots />

        <div>
          <Title
            text={
              <FormattedMessage
                id="editPurchase.changeInventory.title"
                defaultMessage="Change inventory"
              />
            }
            divider
          />
          <p className="cool-grey">
            <FormattedMessage
              id="editPurchase.buySomethingElse.text"
              defaultMessage="Do you want to buy something else that better
                suits your group? No need to start from scratch."
            />
          </p>
          <p className="cool-grey">
            <FormattedMessage
              id="editPurchase.buySomethingElse.instructions.contact"
              defaultMessage="- Contact {email} to let us know what inventory you prefer"
              values={{
                email: (
                  <a href="mailto:info@keytravel.com" target="_blank" rel="noopener noreferrer">
                    info@keytravel.com
                  </a>
                )
              }}
            />
            <br />
            <FormattedMessage
              id="editPurchase.buySomethingElse.instructions.weUpdate"
              defaultMessage="- We will update your existing group and
                apply current contributions towards the new purchase."
            />
          </p>
        </div>
        <div>
          <Title
            text={
              <FormattedMessage
                id="editPurchase.cancelGroup.title"
                defaultMessage="Cancel group"
              />
            }
            divider
          />
          <p className="cool-grey">
            <FormattedMessage
              id="editPurchase.cancelGroup.lastResort"
              defaultMessage="As a last resort, you can"
            />
            {' '}
            <a href="#cancel" onClick={this.props.onCancelPurchase}>
              <FormattedMessage
                id="editPurchase.cancelGroup.link"
                defaultMessage="cancel your group."
              />
            </a>
          </p>
        </div>
        <div className="row mt-3">
          <div className="col-7 small-print">
            {this.renderShortContributorsAlert()}
          </div>
          <div className="col-5">
            <button type="submit" className="btn btn-primary float-right" disabled={submitting}>
              <FormattedMessage
                id="editPurchase.submit"
                defaultMessage="Save changes"
              />
            </button>
          </div>
        </div>
      </form>
    );
  }

  render() {
    return (
      <div className="edit-purchase">
        <div className="modal-section modal-title text-center blue full">
          <h1>
            <FormattedMessage
              id="editPurchase.title"
              defaultMessage="Make changes"
            />
          </h1>
        </div>
        {this.renderAlert()}
        {this.renderForm()}
      </div>
    );
  }
}

EditPurchase.defaultProps = {
  onSubmit: () => {},
  shortMemberships: [],
  onCancelPurchase: () => {},
  purchase: null,
};

export default injectIntl(reduxForm({ form: 'editPurchase', validate })(EditPurchase));



// WEBPACK FOOTER //
// ./src/desktop/components/edit-purchase/index.js